
































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Shared types
import { RequestOfferRequest } from '@coldtec/cos-types';

// Validation
import { Errors } from '@/validation';

/**
 *  Component that renders the directly requesting of the installation,
 *  including a splash and the input fields.
 */
@Component
export default class PersonalDetailsInstallation extends Vue {

    @InjectReactive('request')
    private request!: RequestOfferRequest;

    @InjectReactive('errors')
    private errors!: Errors<RequestOfferRequest>;

    /**
     *  Used to get the fact if the user also
     *  wishes to request the installation.
     */
    private get requestInstallation(): boolean {

        return this.request.requested_installation === 1;

    }

    /**
     *  Used to toggle the fact if the client also
     *  wishes to request the installation.
     */
    private toggle(): void {

        this.request.requested_installation = !this.request.requested_installation ? 1 : 0;

    }

}
